// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2vKx-","requiredAsterisk":"Info_requiredAsterisk__37I_N"};